import { Card, styled } from '@mui/material';

export const ReadOnlyCard = styled(Card)(({ theme }) => ({
  width: '100%',
  paddingBottom: '2rem',
  marginBottom: '2rem',
  backgroundColor: theme.palette.background.paper,
}));

export const QuestionCard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  marginTop: '2rem',
  padding: '2rem',
}));
